<template>
    <button :type="type" @click="onClick()" :disabled="disabled">
        <span v-if="label">{{ label }}</span>
        <span v-else><slot /></span>
    </button>
</template>
<script>
export default {
    name: 'ButtonComponent',
    props: {
        label: {
            type: String,
        },
        type: {
            type: String,
            default: 'button',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onClick() {
            this.$emit('onClick');
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../assets/scss/color.scss';
@import '../assets/scss/font.scss';
@import '../assets/scss/field.scss';

.qb-btn {
    color: $white;
    border: none;
    font-weight: $font-weight-normal-2;
    border-radius: $button-border-radius;
    height: fit-content;
    padding: 6px 15px;

    &-black {
        &-sm {
            background-color: $dark-400;
            font-size: $font-size-sm;
        }
        &-md {
            background-color: $dark-400;
            font-size: $font-size-md;
        }
        &-lg {
            background-color: $dark-400;
            font-size: $font-size-lg;
        }
    }

    &-primary {
        &-sm {
            background-color: $primary-100;
            font-size: $font-size-sm;
        }
        &-md {
            background-color: $primary-100;
            font-size: $font-size-md;
        }
        &-lg {
            background-color: $primary-100;
            font-size: $font-size-lg;
        }
    }

    &-outline {
        &-sm {
            background-color: $white;
            border: 1px solid $dark-fade;
            font-size: $font-size-sm;
            color: $dark-400;
        }
        &-md {
            background-color: $white;
            border: 1px solid $dark-fade;
            font-size: $font-size-md;
            color: $dark-400;
        }
        &-lg {
            background-color: $white;
            border: 1px solid $dark-fade;
            font-size: $font-size-lg;
            color: $dark-400;
        }
    }

    &-danger {
        &-sm {
            background-color: $danger-100;
            font-size: $font-size-sm;
        }
        &-md {
            background-color: $danger-100;
            font-size: $font-size-md;
        }
        &-lg {
            background-color: $danger-100;
            font-size: $font-size-lg;
        }
    }

    &-grey {
        &-sm {
            background-color: $light-400;
            font-size: $font-size-sm;
        }
        &-md {
            background-color: $light-400;
            font-size: $font-size-md;
        }
        &-lg {
            background-color: $light-400;
            font-size: $font-size-lg;
        }
    }

    // &:hover {
    //   background-color: $dark-200;
    // }
    &:disabled {
        background-color: $disabled;
        cursor: not-allowed;
    }
}
</style>
